import user from 'user';
import ec from 'ec';
import Settings from 'settings';

/*global window: false, process */
(function (w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({
    user: getUserData(),
    environment: process.env.NODE_ENV,
    originalLocation: document.location.href,
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
    migration: true
  });
  var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l !== 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://gtm.elisaviihde.fi/gtm.js?id=' + i + dl;
  f.parentNode.insertBefore(j, f);
  trackPage();
})(window, document, 'script', 'dataLayer', Settings.googleTagManagerId);

function getUserData() {
  return {
    services: user.fromDOM().services.toString() || undefined,
    id: user.fromDOM().entertainmentCredentialsId && user.fromDOM().entertainmentCredentialsId > 0 ? user.fromDOM().entertainmentCredentialsId : undefined,
    group: user.getAnalyticsUserGroup() || undefined
  };
}

function setUserData() {
  sendDataLayer({
    user: getUserData()
  });
}

function argsToDataLayer(args) {
  if (args[0] === 'pageview') {
    sendDataLayer({
      event: 'customPage',
      customPage: {
        path: args[1] || document.location.pathname + document.location.search + document.location.hash
      }
    });
  } else if (args[0] === 'event') {
    sendDataLayer({
      event: 'customEvent',
      customEvent: {
        category: args[1],
        action: args[2],
        label: args[3],
        metadata: args[4]
      }
    });
  } else if (args[0] === 'exception') {
    sendDataLayer({
      event: 'customError',
      customError: args[1]
    });
  }
}

function gaArgs() {
  var args = Array.prototype.slice.call(arguments, 0);
  argsToDataLayer(args);
}

function setCustomDimension(dimension, dimensionValue) {
  switch (dimension) {
    case 'dimension4':
      sendDataLayer({playerType: dimensionValue});
      break;
    case 'dimension5':
      sendDataLayer({playerMode: dimensionValue});
      break;
    case 'dimension6':
      sendDataLayer({loginType: dimensionValue});
      break;
    case 'dimension8':
      sendDataLayer({user: {group: dimensionValue}});
      break;
  }
}

function trackPage(args) {
  var promos = ec.addImpressions();
  if (promos.length) {
    sendDataLayer({
      ecommerce: {
        promoView: {
          promotions: promos
        }
      }
    });
  }

  setUserData();

  if (args) {
    gaArgs.bind(null, "pageview").call(gaArgs, args);
  } else {
    gaArgs.bind(null, "pageview").call(gaArgs);
  }
}

function sendDataLayer(obj) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(obj);
}

export default {
  trackWithSection: gaArgs.bind(null, "event", ec.getSection()),
  track: gaArgs.bind(null, "event"),
  trackError: gaArgs.bind(null, "exception"),
  trackPage: trackPage,
  trackPurchase: function (args) {
    sendDataLayer(ec.trackPurchase(args));
  },
  trackProductView: function (productId, name, index) {
    sendDataLayer(ec.trackProductView(productId, name, index));
  },
  trackBannerClick: function (bannerImage, bannerType, bannerTarget) {
    sendDataLayer(ec.trackBannerClick(bannerImage, bannerType));
    this.trackWithSection("banner-click", bannerTarget);
  },
  trackRecording: function (eventType, data) {
    var analyticsData = '';
    if (data.programId) {
      analyticsData = "Program: " + data.programId;
    }
    if (data.channelId) {
      analyticsData = "Channel: " + data.channelId;
    }
    analyticsData += eventType === "wildcard" ? " Rule: " + data.rule : '';

    if (data.folderId) {
      analyticsData += " Folder: " + data.folderId;
    }

    this.trackWithSection("record-" + eventType, analyticsData);
  },
  trackCheckout: function (step, option, productObj) {
    sendDataLayer(ec.trackCheckout(step, option, productObj));
  },
  trackRegistrationStart: gaArgs.bind(null, "event", "registerStart"),
  setCustomDimension: setCustomDimension
};



// WEBPACK FOOTER //
// ./web/js/analytics.js